import { axiosGet, axiosPost } from "../../react_axios/Axios";
import moment from "moment";
import { CHAT_DETAILS_ACTION_TYPE, CHAT_INSERT_ACTION_TYPE, chatDetailsUrl,headers,sendChatUrl } from "../../utils/constants";

export const chat_detail_action =
  (OrderID, ServiceID, VendorID) => async (dispatch) => {
    try {
      const params = {
        OrderID: OrderID,
        ServiceID: ServiceID,
        VendorID: VendorID,
      };
      console.log("chat_detail_action mapdata...", params);
      const res = await axiosGet(
        chatDetailsUrl,
        params,
        headers
      );
      console.log("chat_detail_action", res);
      dispatch({
        type: CHAT_DETAILS_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

  export const insert_chat_action =
  (
    OrderID,
    VendorID,
    ServiceID,
    chat,
    isClient
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
            OrderID:OrderID,
        VendorID: VendorID,
        ServiceID: ServiceID,
        chat: chat,
        isClient: isClient
      };
      console.log("insert_chat_action add mapdata...", mapdata);

      const res = await axiosPost(sendChatUrl, mapdata, headers);
      dispatch({
        type: CHAT_INSERT_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
